/**
 * @generated SignedSource<<560ba0630c9797db6a1befe464a6559f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
export type VideoField_ProfileVideoQuery$variables = {
  videoId?: string | null | undefined;
};
export type VideoField_ProfileVideoQuery$data = {
  readonly currentUser: {
    readonly configuration: {
      readonly videoMaxDuration: number | null | undefined;
      readonly videoMinDuration: number | null | undefined;
    } | null | undefined;
    readonly status: UserStatus | null | undefined;
  } | null | undefined;
  readonly featuredFreelancers: ReadonlyArray<{
    readonly video: {
      readonly " $fragmentSpreads": FragmentRefs<"SampleVideosButton_SampleVideos">;
    } | null | undefined;
  }> | null | undefined;
  readonly video: {
    readonly id?: string;
    readonly question?: {
      readonly title: string;
    } | null | undefined;
    readonly url?: string;
    readonly " $fragmentSpreads": FragmentRefs<"StoredVideo_Video">;
  } | null | undefined;
};
export type VideoField_ProfileVideoQuery = {
  response: VideoField_ProfileVideoQuery$data;
  variables: VideoField_ProfileVideoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "videoId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Configuration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoMaxDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoMinDuration",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "videoId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optimizedUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "posterUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableSubtitles",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoField_ProfileVideoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "featuredFreelancers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SampleVideosButton_SampleVideos"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "video",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoredVideo_Video"
              }
            ],
            "type": "Video",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoField_ProfileVideoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "featuredFreelancers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "video",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v1/*: any*/),
              (v9/*: any*/)
            ],
            "type": "Video",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c9b3bf38544c8fbd2550a3e936dec1a",
    "id": null,
    "metadata": {},
    "name": "VideoField_ProfileVideoQuery",
    "operationKind": "query",
    "text": "query VideoField_ProfileVideoQuery(\n  $videoId: ID\n) {\n  currentUser {\n    status\n    configuration {\n      videoMaxDuration\n      videoMinDuration\n    }\n    id\n  }\n  featuredFreelancers {\n    video {\n      ...SampleVideosButton_SampleVideos\n      id\n    }\n    id\n  }\n  video: optionalNode(id: $videoId) {\n    __typename\n    ... on Video {\n      id\n      url\n      question {\n        title\n        id\n      }\n      ...StoredVideo_Video\n    }\n    id\n  }\n}\n\nfragment SampleVideosButton_SampleVideos on Video {\n  id\n  ...Video_Video\n}\n\nfragment StoredVideo_Video on Video {\n  id\n  optimizedUrl\n  posterUrl\n  status\n  ...Video_Video\n}\n\nfragment Video_Video on Video {\n  id\n  url\n  optimizedUrl\n  posterUrl\n  enableSubtitles\n}\n"
  }
};
})();

(node as any).hash = "f6124ec1e14ad388d76c3bb4825a3ce7";

export default node;
